import { render, staticRenderFns } from "./GroupItem.vue?vue&type=template&id=c3d14966&scoped=true&"
import script from "./GroupItem.ts?vue&type=script&lang=ts&"
export * from "./GroupItem.ts?vue&type=script&lang=ts&"
import style0 from "./GroupItem.vue?vue&type=style&index=0&id=c3d14966&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d14966",
  null
  
)

export default component.exports